import React from 'react';
import { useQuotaNotification } from '@/contexts/QuotaNotificationContext';
import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';

const QuotaNotificationBanner: React.FC = () => {
  const { isBannerVisible, bannerMessage, hideQuotaNotification } = useQuotaNotification();

  if (!isBannerVisible) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-100 border-b-2 border-yellow-500 text-yellow-700 p-4 shadow-lg z-[9999]" role="alert">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center">
          <InformationCircleIcon className="h-6 w-6 text-yellow-500 mr-4 flex-shrink-0" />
          <div>
            <p className="font-bold">Usage Limit Reached</p>
            <p className="text-sm">{bannerMessage}</p>
          </div>
        </div>
        <div className="flex items-center ml-4">
          <Link 
            to="/pricing" 
            onClick={hideQuotaNotification} 
            className="bg-yellow-500 text-white font-bold py-2 px-4 rounded hover:bg-yellow-600 transition-colors text-sm whitespace-nowrap"
          >
            Upgrade Plan
          </Link>
          <button
            onClick={hideQuotaNotification}
            className="ml-4 p-1"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5 text-yellow-600 hover:text-yellow-800" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotaNotificationBanner;
